var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    fill: "none",
    viewBox: "0 0 15 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_6334_18962)",
    d: "M.434.554C.25.74.125 1.05.125 1.422v13.71c0 .372.124.682.31.868l.061.062L8.172 8.37v-.124L.434.554Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_6334_18962)",
    d: "M10.837 10.814 8.299 8.271v-.124l2.538-2.543.062.062 3.033 1.737c.866.496.866 1.302 0 1.799l-3.095 1.612Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_6334_18962)",
    d: "m10.84 10.752-2.6-2.606-7.676 7.755c.31.31.743.31 1.3.062l8.976-5.211Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_6334_18962)",
    d: "M10.837 5.541 1.8.392C1.243.082.81.144.5.454L8.237 8.21l2.6-2.668Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.834 10.69-8.976 5.087c-.495.31-.928.248-1.238 0l-.061.062.061.062c.31.248.743.31 1.238 0l8.976-5.21Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.561 15.778c-.185-.186-.309-.497-.309-.869v.062c0 .372.124.683.31.869v-.062ZM13.868 8.953l-3.095 1.737.062.062 3.033-1.737c.434-.248.62-.558.62-.869 0 .31-.186.559-.62.807Z",
    opacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.8.454 13.87 7.34c.371.248.619.496.619.807 0-.31-.186-.62-.62-.869L1.8.392C.933-.104.252.33.252 1.322v.063c0-.993.68-1.427 1.547-.93Z",
    opacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6334_18962",
    x1: 7.444,
    x2: -2.967,
    y1: 1.298,
    y2: 11.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6334_18962",
    x1: 15.02,
    x2: 0.042,
    y1: 8.142,
    y2: 8.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6334_18962",
    x1: 9.447,
    x2: -4.671,
    y1: 9.565,
    y2: 23.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6334_18962",
    x1: -1.406,
    x2: 4.898,
    y1: -4.157,
    y2: 2.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgGooglePlay;